import { sendPost } from "@/utils/request.js";
// 获取工会信息
const unionSource = "/mallunion/getLogo";
function getUnionSource(data) {
  return sendPost(unionSource, data, true);
}

// 获取授权码
const authCode = "/user/login/external/getcode";
function getAuthCode(data) {
  return sendPost(authCode, data);
}

// 获取确认订单信息
const confirmSource = "/goods/show/queryShowBookingOrderPage";
function getConfirmSource(data) {
  return sendPost(confirmSource, data);
}
// 获取自助换票地址信息
const machineSource = "/trade/showOrder/getExchangePoint";
function getMachineSource(data) {
  return sendPost(machineSource, data);
}

// 获取用户手机号接口
function getUserPhone(data) {
  const url = "/trade/showOrder/getUserPhone";
  return sendPost(url, data);
}

// 获取确认订单 发送信息
const sendSource = "/trade/showOrder/sendVerificationCodeMsg";
function getSendCode(data) {
  return sendPost(sendSource, data);
}
// 获取确认订单 确认信息
const confirmCode = "/trade/showOrder/verifyVerificationCode";
function getConfirmCode(data) {
  return sendPost(confirmCode, data);
}

//创建订单
const createdOrder = "/trade/showOrder/createOrder";
function getCreatedOrder(data) {
  return sendPost(createdOrder, data);
}
//获取订单列表
const listOrder = "/mall/order/show/queryShowOrders";
function getListOrder(data) {
  return sendPost(listOrder, data);
}
// 获取工会订单列表
const orderList = "/user/menu/list";
function getOrderList(data) {
  return sendPost(orderList, data, true);
}
//获取订单详情
const detailOrder = "/mall/order/show/queryShowOrderDetail";
function getDetailOrder(data) {
  return sendPost(detailOrder, data);
}
//立即支付
const payOrder = "/trade/showOrder/pay";
function getPayOrder(data) {
  return sendPost(payOrder, data);
}
//取消订单
const cancelOrder = "/trade/showOrder/cancelOrder";
function getCancelOrder(data) {
  return sendPost(cancelOrder, data);
}

// 获取公告
const noticeApi = "/notice/noticeContent";
function getNotice(data) {
  return sendPost(noticeApi, data, false);
}

// 切换城市掉一下接口，不用管返回内容
const changeCityApi = "/location/changecity";
function changeCity(city) {
  var data = {
    city: city
  };
  return sendPost(changeCityApi, data, true);
}

// 判断首页有没有健身
const fitness = "/health/homepage";
function fitnessFlag(city) {
  var data = {
    platform: 0,
    city: city
  };
  return sendPost(fitness, data, true);
}

// 判断是否灰度
function getMallGray(params) {
  const url = "/trade/showOrder/isMallGrayScale";
  return sendPost(url, params);
}

// 判断是否登陆
function getLoginStatus(params) {
  const url = "/user/checkLogin";
  return sendPost(url, params, true);
}
// 获取全部收货地址
function getAddressAll(params) {
  const url = "/address/userNewAddressContract/queryUserAddressList";
  //const url = "/web/queryUserAddressList";
  return sendPost(url, params);
}
// 删除收货地址
function getDelAddress(params) {
  const url = "/address/userNewAddressContract/deleteUserAddress";
  //const url = "/deleteUserAddress";
  return sendPost(url, params);
}
// 编辑收货地址
function getEditAddress(params) {
  const url = "/address/userNewAddressContract/update";
  //const url = "/updateUserAddress";
  return sendPost(url, params);
}
// 新增收货地址
function getNewAddAddress(params) {
  const url = "/address/userNewAddressContract/creat";
  return sendPost(url, params);
}
// 获取用户最后一次下单地址
function getLastAddress(params) {
  const url = "/mall/order/show/queryLastOrderAddressId";
  return sendPost(url, params);
}
// 确认订单页运费
function getCalculateExpressFee(params) {
  const url = "/trade/showOrder/calculateExpressFee";
  return sendPost(url, params);
}

//获取物流详情
function getLogDetail(params) {
  const url = "/mall/order/show/queryExpressOrder";
  return sendPost(url, params);
}

export default {
  getLastAddress,
  getCalculateExpressFee,
  getAddressAll,
  getDelAddress,
  getEditAddress,
  getNewAddAddress,
  getUnionSource,
  getConfirmSource,
  getMachineSource,
  getSendCode,
  getConfirmCode,
  getCreatedOrder,
  getListOrder,
  getOrderList,
  getDetailOrder,
  getPayOrder,
  getCancelOrder,
  getNotice,
  changeCity,
  fitnessFlag,
  getMallGray,
  getLoginStatus,
  getUserPhone,
  getLogDetail,
  getAuthCode
};
